var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "sync-manage"
  }, [_vm._m(0), !_vm.unitCode ? _c('Alert', {
    staticClass: "sync-alert",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(` ${$t("vlublah", "当前单位代码缺失，无法查询同步数据")} `)]) : _vm._e(), _c('Tabs', {
    staticClass: "sync-tabs",
    on: {
      "on-click": _vm.onTabChange
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": $t("eve9fc4", "状态总览"),
      "name": "overview"
    }
  }, [_c('SyncOverviewTab', {
    ref: "overviewTab",
    attrs: {
      "active": _vm.activeTab === 'overview',
      "unit-code": _vm.unitCode,
      "overview": _vm.overview
    },
    on: {
      "show-alerts": _vm.showAlertsTab
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": $t("b2272y4", "同步配置"),
      "name": "config"
    }
  }, [_c('SyncConfigTab', {
    ref: "configTab",
    attrs: {
      "active": _vm.activeTab === 'config',
      "app-id": _vm.appId,
      "unit-code": _vm.unitCode,
      "configs": _vm.configs,
      "overview": _vm.overview,
      "downstream-options": _vm.downstreamOptions,
      "active-system": _vm.activeSystem
    },
    on: {
      "update:active-system": function ($event) {
        _vm.activeSystem = $event;
      },
      "saved": _vm.reloadConfigContext
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": _vm.alertTabLabel,
      "name": "alerts"
    }
  }, [_c('SyncAlertsTab', {
    ref: "alertsTab",
    attrs: {
      "app-id": _vm.appId,
      "unit-code": _vm.unitCode,
      "downstream-options": _vm.downstreamOptions
    },
    on: {
      "alert-count-change": _vm.updateAlertTabCount,
      "operation-result": _vm.showOperationResult
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": $t("b1un1n4", "同步日志"),
      "name": "logs"
    }
  }, [_c('SyncLogsTab', {
    ref: "logsTab",
    attrs: {
      "app-id": _vm.appId,
      "unit-code": _vm.unitCode,
      "downstream-options": _vm.downstreamOptions
    },
    on: {
      "show-alerts": _vm.showAlertsTab,
      "operation-result": _vm.showOperationResult,
      "refresh-alert-count": _vm.loadOverview
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": $t("i5qczl4", "账号清单"),
      "name": "accounts"
    }
  }, [_c('SyncAccountsTab', {
    ref: "accountsTab",
    attrs: {
      "app-id": _vm.appId,
      "unit-code": _vm.unitCode,
      "downstream-options": _vm.downstreamOptions
    },
    on: {
      "operation-result": _vm.showOperationResult
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "sync-page-header"
  }, [_c('div', [_c('h1', [_vm._v($t("b1yg4e4", "同步管理"))]), _c('p', {
    staticClass: "sync-desc"
  }, [_vm._v(` ${$t("xj33dz16", "iWork → UC / iHotel / iCater 用户数据同步配置与状态监控")} `)])])]);
}];
export { render, staticRenderFns };